/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_LobbyInputs */

const en_footer_action_lobby = /** @type {(inputs: Footer_Action_LobbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lobby tips`)
};

/**
* | output |
* | --- |
* | "Lobby tips" |
*
* @param {Footer_Action_LobbyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_lobby = /** @type {((inputs?: Footer_Action_LobbyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_LobbyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_lobby(inputs)
});